import React from "react";
import { Container, Row, Col } from "reactstrap";

import { FaCircle } from "react-icons/fa";

function TextGrid() {
  let pageHeader = React.createRef();
  const size =
    document.body.clientWidth >= 1024 || document.documentElement.clientWidth >= 1024
      ? true
      : false;
  return (
    <>
      {events.map((e) => (
        <div
          style={{
            backgroundColor: "#fff",
          }}
          className="section"
          data-parallax={true}
          ref={pageHeader}
        >
          <Container>
            <Row className="justify-content-center mb-5">
              <Col md={12}>
                <div className="container-fluid row justify-content-center">
                  <Col lg={6} xs={12} className={`${!size && "text-center pb-3"}`}>
                    <img
                      src={e.logo}
                      style={{ maxWidth: size ? "450px" : "250px" }}
                      width="100%"
                      alt="dt22"
                    />
                  </Col>
                  <Col lg={6} xs={12} className="align-self-center">
                    <h3
                      className="text-400 mt-0 text-dark"
                      style={{
                        borderTop: !size && "1px solid #fff",
                        paddingTop: !size && "20px",
                        borderLeft: size && "1px solid #fff",
                        paddingLeft: size && "20px",
                      }}
                    >
                      {e.location},
                      <br />
                      {e.date}
                    </h3>
                  </Col>
                </div>
              </Col>
            </Row>
            <Row className="justify-content-center">
              <Col lg={4}>
                <div className="container-fluid row">
                  {e.stats.map((c) => (
                    <Col lg={6} xs={6} className="text-center text-dark mb-3">
                      <img
                        src={require(`assets/icons/${c.image}`)}
                        style={{ maxWidth: "70px" }}
                        width="100%"
                        alt="dt22"
                      />
                      <h4 className="text-900 text-g-p mt-1">{c.value}</h4>
                      <p className="text-400 " style={{ fontSize: "16px" }}>
                        {c.title}
                      </p>
                    </Col>
                  ))}
                </div>
              </Col>
              <Col lg={4} className={`${!size && "text-center mb-3"}`}>
                <img
                  src={e.piechart}
                  style={{ maxWidth: size ? "350px" : "250px" }}
                  width="100%"
                  alt="dt22"
                />
              </Col>
              <Col lg={4}>
                {e.profiles.map((p) => (
                  <h5 className="text-400 mt-0 text-dark pt-2">
                    <FaCircle className="mr-3" style={{ color: p.color }} />
                    {p.title} - {p.value}
                  </h5>
                ))}
              </Col>
            </Row>
          </Container>
        </div>
      ))}
    </>
  );
}

export default TextGrid;

const events = [
  {
    logo: require("assets/pastevent/nz.png"),
    location: "Mövenpick Hotel Auckland, New Zealand",
    date: "MAY 8-9, 2024",
    stats: [
      { title: "SPEAKERS", value: 33, image: "p5.png" },
      { title: "ATTENDEES", value: 191, image: "p6.png" },
      { title: "SPONSORS", value: 7, image: "p7.png" },
      { title: "WORKSHOP DELEGATES", value: 31, image: "p8.png" },
    ],
    piechart: require("assets/icons/4piechart.png"),
    profiles: [
      { title: "ENGINEERING", value: "21.9%", color: "#42467B" },
      { title: "CONSULTANT", value: "27.3%", color: "#362D6F" },
      { title: "SOFTWARE PROVIDER", value: "21.9%", color: "#212961" },
      { title: "DEVELOPER", value: "2.8%", color: "#789FA8" },
      { title: "PROJECT OWNER ", value: "14.6%", color: "#AA7C95" },
      { title: "ARCHITECTURE", value: "5.6%", color: "#896C92" },
      { title: "CONTRACTOR", value: "6.2%", color: "#AA7C95" },
      { title: "FM", value: "1.6%", color: "#594A86" },
    ],
  },
  // {
  //   logo: require("assets/pastevent/me.png"),
  //   location: "HABTOOR PALACE, DUBAI UAE",
  //   date: "MARCH 20-21, 2024",
  //   stats: [
  //     { title: "SPEAKERS", value: 35, image: "p1.png" },
  //     { title: "ATTENDEES", value: 282, image: "p2.png" },
  //     { title: "EXHIBITORS", value: 12, image: "p3.png" },
  //     { title: "WORKSHOP DELEGATES", value: 21, image: "p4.png" },
  //   ],
  //   piechart: require("assets/icons/3piechart.png"),
  //   profiles: [
  //     { title: "ENGINEERING", value: "14.5%", color: "#3E8BA4" },
  //     { title: "CONSULTANTS", value: "21.1%", color: "#6A6C98" },
  //     { title: "SOFTWARE PROVIDERS", value: "27.5%", color: "#5F9696" },
  //     { title: "DEVELOPERS", value: "10%", color: "#858688" },
  //     { title: "PROJECT OWNERS", value: "9.4%", color: "#384881" },
  //     { title: "ARCHITECTURE", value: "6.6%", color: "#50467B" },
  //     { title: "CONTRACTOR", value: "7.3%", color: "#5990B5" },
  //     { title: "FM", value: "2.4%", color: "#5990B5" },
  //   ],
  // },

  // {
  //   logo: require("assets/pastevent/ksa.png"),
  //   location: "RIYADH AIRPORT MARRIOTT HOTEL, RIYADH, KSA",
  //   date: "OCTOBER 8-9, 2024",
  //   stats: [
  //     { title: "SPEAKERS", value: 34, image: "p5.png" },
  //     { title: "ATTENDEES", value: 365, image: "p6.png" },
  //     { title: "EXHIBITORS", value: 14, image: "p7.png" },
  //     { title: "WORKSHOP DELEGATES", value: 81, image: "p8.png" },
  //   ],
  //   piechart: require("assets/icons/2piechart.png"),
  //   profiles: [
  //     { title: "CONSULTANT ", value: "15.5%", color: "#4F8436" },
  //     { title: "ENGINEERING ", value: "7.4%", color: "#6B9890" },
  //     { title: "CONTRACTOR", value: "19.2%", color: "#78A342" },
  //     { title: "DEVELOPERS", value: "19.2%", color: "#9E9B3C" },
  //     { title: "PROJECT OWNERS", value: "28.2%", color: "#377B3C" },
  //     { title: "SOFTWARE PROVIDER", value: "3.8%", color: "#9E9B3C" },
  //     { title: "ARCHITECTURE", value: "3.1%", color: "#94BEA9" },
  //     { title: "FM ", value: "2.6%", color: "#49A2C0" },
  //   ],
  // },
  // {
  //   logo: require("assets/pastevent/uk.png"),
  //   location: "ONE GREAT GEORGE STREET LONDON, UK",
  //   date: "OCTOBER 30-31, 2024",
  //   stats: [
  //     { title: "SPEAKERS", value: 40, image: "p5.png" },
  //     { title: "ATTENDEES", value: 155, image: "p6.png" },
  //     { title: "EXHIBITORS", value: 5, image: "p7.png" },
  //     { title: "WORKSHOP DELEGATES", value: 37, image: "p8.png" },
  //   ],
  //   piechart: require("assets/icons/1piechart.png"),
  //   profiles: [
  //     { title: "CONSULTANT", value: "33.3%", color: "#362D6F" },
  //     { title: "ENGINEERING", value: "10.2%", color: "#42467B" },
  //     { title: "DEVELOPER", value: "5.4%", color: "#789FA8" },
  //     { title: "CONTRACTOR", value: "8.2%", color: "#AA7C95" },
  //     { title: "PROJECT OWNER ", value: "8.2%", color: "#AA7C95" },
  //     { title: "SOFTWARE PROVIDER", value: "25.9%", color: "#212961" },
  //     { title: "ARCHITECTURE", value: "7.5%", color: "#896C92" },
  //     { title: "FM", value: "1.4%", color: "#594A86" },
  //   ],
  // },
];
